'use strict';

var _ = require('lodash');

var measurementNormalTheme = 'lightGreen';
var measurementLeftTheme = 'lightOrange';

var DECIMAL_PLACES = 2;
var SD_MAX = 3;
var SD_MIN = -3;
var PERCENTILE_MAX = 99.9;
var PERCENTILE_MIN = 0;

var MAX_UPLOAD_FILE_ZIE = 1000 * 1000 * 100; // 100Mb
var ACCEPTED_MIME_TYPES = [];

var IMAGE_RESIZING_PARAMS = {
	TARGET_RESOLUTION: 480,
		MIN_QUALITY: 75,
		MAX_QUALITY: 100,
		MAX_IMAGE_FILE_SIZE_BYTES: 6291456,
		MAX_FILE_SIZE_BYTES: 26214400
};

var pusherEventTypes = {
    QUICK_GESTALT: 'quick_gestalt_syndromes',
	COMBINED_LIST_SYNDROMES: 'combined_list_syndromes',
	SUGGESTED_FEATURES: 'suggested_features',
	FACIAL_D_SCORE: 'dscore',
	GESTAL_MATCHER_ULTRARARE_UNDIAGNOSED: 'gm_results',
	TSNE_IMAGE: 'tsne_results',
	UNDIAGNOSED_TSNE: 'undiagnosed_tsne'
};


var CaseType = {
    CASE_TYPE_ITEM_MYCASE: "My Case",
    CASE_TYPE_ITEM_TEAMCASE: "Team Case"
};

var Gender = {
    GENDER_MALE : "Male",
    GENDER_FEMALE : "Female",
    GENDER_OTHER : "Other"
};

var Ethnicity = _.get(window, 'case_constants.ethnicities', []);
var Inheritance = _.get(window, 'case_constants.inheritance_modes', []);

var Exclusion = ['Normal SNP Microarray', 'Normal Karyotype', 'Normal Intellectual Ability'];

var ChartList = ['Height', 'Weight', 'Head Circumference'];


var UserTitle  = _.get(window, 'user_constants.titles', []);
var Profession = _.get(window, 'user_constants.professionsDictionary', []);
var Speciality = _.get(window, 'user_constants.specialitiesDictionary', []);
var Countries = ["Afghanistan","Åland Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia, Plurinational State of","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Congo, the Democratic Republic of the","Cook Islands","Costa Rica","Côte d'Ivoire","Croatia","Cuba","Curaçao","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See (Vatican City State)","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran, Islamic Republic of","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea, Democratic People's Republic of","Korea, Republic of","Kuwait","Kyrgyzstan","Lao People's Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Macedonia, the former Yugoslav Republic of","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia, Federated States of","Moldova, Republic of","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestinian Territory, Occupied","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Réunion","Romania","Russian Federation","Rwanda","Saint Barthélemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Swaziland","Sweden","Switzerland","Syrian Arab Republic","Taiwan, Province of China","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Venezuela, Bolivarian Republic of","Viet Nam","Virgin Islands, British","Virgin Islands, U.S.","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"];

var CaseStatus = {
    CREATED: 'CREATED',
    ANALYZED: 'ANALYZED',
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    DIAGNOSED: 'DIAGNOSED',
    PENDING: 'PENDING',
    UNDIAGNOSED: 'UNDIAGNOSED'
};

var CaseDiagnosis = {
    CASE_STATUS_DIFFERENTIAL: 'DIFFERENTIAL_DIAGNOSIS',
    CASE_STATUS_CLINICAL: 'CLINICALLY_DIAGNOSED',
    CASE_STATUS_MOLECULAR: 'MOLECULARLY_DIAGNOSED'
};

var OrderDiagnosesScore = {};
OrderDiagnosesScore[CaseDiagnosis.CASE_STATUS_MOLECULAR]    = 1;
OrderDiagnosesScore[CaseDiagnosis.CASE_STATUS_CLINICAL]     = 100;
OrderDiagnosesScore[CaseDiagnosis.CASE_STATUS_DIFFERENTIAL] = 1000;

var syndromeDiagnosisOptions = [{
	label: 'Differential',
	enum: CaseDiagnosis.CASE_STATUS_DIFFERENTIAL
}, {
	label: 'Clinically Diagnosed',
	enum: CaseDiagnosis.CASE_STATUS_CLINICAL
}, {
	label: 'Molecularly Diagnosed',
	enum: CaseDiagnosis.CASE_STATUS_MOLECULAR
}];

var geneDiagnosisOptions = [{
	label: 'Molecularly Diagnosed',
	enum: CaseDiagnosis.CASE_STATUS_MOLECULAR
}, {
	label: 'Differential',
	enum: CaseDiagnosis.CASE_STATUS_DIFFERENTIAL
}];

var Measurements = [{"measurement_type_id":"1","measurement_label":"Height","measurement_group_id":"1","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Height"},{"measurement_type_id":"2","measurement_label":"Weight","measurement_group_id":"2","unit_type":"weight_unit","unit_size":"KG","measurement_group_label":"Weight"},{"measurement_type_id":"3","measurement_label":"Head Circumference","measurement_group_id":"3","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Head Circumference"},{"measurement_type_id":"4","measurement_label":"Interpupillary Distance","measurement_group_id":"4","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Interpupillary Distance"},{"measurement_type_id":"5","measurement_label":"Inner Canthal Distance","measurement_group_id":"5","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Inner Canthal Distance"},{"measurement_type_id":"6","measurement_label":"Outer Canthal Distance","measurement_group_id":"6","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Outer Canthal Distance"},{"measurement_type_id":"7","measurement_label":"Palpebral Fissure Length (L)","measurement_group_id":"7","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Palpebral Fissure Length"},{"measurement_type_id":"8","measurement_label":"Palpebral Fissure Length (R)","measurement_group_id":"7","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Palpebral Fissure Length"},{"measurement_type_id":"9","measurement_label":"Ear Length (L)","measurement_group_id":"8","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Ear Length"},{"measurement_type_id":"10","measurement_label":"Ear Length (R)","measurement_group_id":"8","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Ear Length"},{"measurement_type_id":"11","measurement_label":"Hand Length (L)","measurement_group_id":"9","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Hand Length"},{"measurement_type_id":"12","measurement_label":"Hand Length (R)","measurement_group_id":"9","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Hand Length"},{"measurement_type_id":"13","measurement_label":"Palm Length (L)","measurement_group_id":"10","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Palm Length"},{"measurement_type_id":"14","measurement_label":"Palm Length (R)","measurement_group_id":"10","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Palm Length"},{"measurement_type_id":"15","measurement_label":"Chest Circumference","measurement_group_id":"11","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Chest Circumference"},{"measurement_type_id":"16","measurement_label":"Internipple Distance","measurement_group_id":"12","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Internipple Distance"},{"measurement_type_id":"17","measurement_label":"Foot Length (L)","measurement_group_id":"13","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Foot Length"},{"measurement_type_id":"18","measurement_label":"Foot Length (R)","measurement_group_id":"13","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Foot Length"}];
var GroupedMeasurements = [{"measurement_group_id":"1","measurement_group_label":"Height","measurements":[{"measurement_type_id":"1","measurement_label":"Height","measurement_group_id":"1","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Height"}]},{"measurement_group_id":"2","measurement_group_label":"Weight","measurements":[{"measurement_type_id":"2","measurement_label":"Weight","measurement_group_id":"2","unit_type":"weight_unit","unit_size":"KG","measurement_group_label":"Weight"}]},{"measurement_group_id":"3","measurement_group_label":"Head Circumference","measurements":[{"measurement_type_id":"3","measurement_label":"Head Circumference","measurement_group_id":"3","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Head Circumference"}]},{"measurement_group_id":"4","measurement_group_label":"Interpupillary Distance","measurements":[{"measurement_type_id":"4","measurement_label":"Interpupillary Distance","measurement_group_id":"4","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Interpupillary Distance"}]},{"measurement_group_id":"5","measurement_group_label":"Inner Canthal Distance","measurements":[{"measurement_type_id":"5","measurement_label":"Inner Canthal Distance","measurement_group_id":"5","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Inner Canthal Distance"}]},{"measurement_group_id":"6","measurement_group_label":"Outer Canthal Distance","measurements":[{"measurement_type_id":"6","measurement_label":"Outer Canthal Distance","measurement_group_id":"6","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Outer Canthal Distance"}]},{"measurement_group_id":"7","measurement_group_label":"Palpebral Fissure Length","measurements":[{"measurement_type_id":"7","measurement_label":"Palpebral Fissure Length (L)","measurement_group_id":"7","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Palpebral Fissure Length"},{"measurement_type_id":"8","measurement_label":"Palpebral Fissure Length (R)","measurement_group_id":"7","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Palpebral Fissure Length"}]},{"measurement_group_id":"8","measurement_group_label":"Ear Length","measurements":[{"measurement_type_id":"9","measurement_label":"Ear Length (L)","measurement_group_id":"8","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Ear Length"},{"measurement_type_id":"10","measurement_label":"Ear Length (R)","measurement_group_id":"8","unit_type":"length_unit","unit_size":"MM","measurement_group_label":"Ear Length"}]},{"measurement_group_id":"9","measurement_group_label":"Hand Length","measurements":[{"measurement_type_id":"11","measurement_label":"Hand Length (L)","measurement_group_id":"9","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Hand Length"},{"measurement_type_id":"12","measurement_label":"Hand Length (R)","measurement_group_id":"9","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Hand Length"}]},{"measurement_group_id":"10","measurement_group_label":"Palm Length","measurements":[{"measurement_type_id":"13","measurement_label":"Palm Length (L)","measurement_group_id":"10","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Palm Length"},{"measurement_type_id":"14","measurement_label":"Palm Length (R)","measurement_group_id":"10","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Palm Length"}]},{"measurement_group_id":"11","measurement_group_label":"Chest Circumference","measurements":[{"measurement_type_id":"15","measurement_label":"Chest Circumference","measurement_group_id":"11","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Chest Circumference"}]},{"measurement_group_id":"12","measurement_group_label":"Internipple Distance","measurements":[{"measurement_type_id":"16","measurement_label":"Internipple Distance","measurement_group_id":"12","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Internipple Distance"}]},{"measurement_group_id":"13","measurement_group_label":"Foot Length","measurements":[{"measurement_type_id":"17","measurement_label":"Foot Length (L)","measurement_group_id":"13","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Foot Length"},{"measurement_type_id":"18","measurement_label":"Foot Length (R)","measurement_group_id":"13","unit_type":"length_unit","unit_size":"CM","measurement_group_label":"Foot Length"}]}];

var ImageTypes = {
	FRONTAL: 'frontalFace',
	LEFT_PROFILE: 'leftSideFace',
	RIGHT_PROFILE: 'rightSideFace',
	PARENT: 'parent',
	SIBILING: 'sibling',
	OTHER: 'other'
};

var ImageTypeLabels = {
	frontalFace: 'Frontal',
	leftSideFace: 'Left Profile',
	rightSideFace: 'Right Profile',
	parent: 'Parent',
	sibling: 'Sibling',
	other: 'Other'
};

var CASE_ACCESS_LEVELS = {
	RESTRICTED: 'restricted',
	OPEN: 'open'
};

var PRIVACY_ITEMS = {
	PRIVATE: 'Private Access',
	CONTROLLED: 'Controlled Access',
	COLLABORATIVE: 'Collaborative Access',
	OPEN: 'Open Access',
	SHARED: 'Shared Access'
};

var PRIVACY_ITEMS_DESCRIPTION = {
	PRIVATE: 'Case information is not shared with anyone else.',
	CONTROLLED: 'Case information is shared only with team members within your institution.',
	COLLABORATIVE: 'Case information is consented and is also visible to Forum members that may be outside your institution.',
	SHARED: 'Shared Access'
};

var SUBSCRIPTION_TYPES = {
	INDIVIDUAL: 'Individual',
	INSTITUTIONAL: 'Institutional'
};

var LMD_SUBSCRIPTION_INFO = {
	INDIVIDUAL: "An Individual license is for use by one user with a single username and password associated with their Face2Gene Library | LMD subscription.",
	INSTITUTIONAL: "An Institutional Network license is for two or more users who have their own unique user credentials while sharing the same network subscription of Face2Gene Library | LMD.  These licenses must initially be set up in advance by contacting support@fdna.com with the number of network users. Designated users must register in advance before a network subscription is activated."
};

var SUBSCRIPTION_PLANS = [{
	id: 'Individual Monthly',
	label: 'Monthly Plan: $10/mo',
	group: SUBSCRIPTION_TYPES.INDIVIDUAL
},
	{
		id: 'Individual Yearly',
		label: 'Annual Plan: $120/yr',
		group: SUBSCRIPTION_TYPES.INDIVIDUAL
	},
	{
		id: 'Institution Monthly',
		label: 'Monthly Plan: $25/mo',
		group: SUBSCRIPTION_TYPES.INSTITUTIONAL
	},
	{
		id: 'Institution Yearly',
		label: 'Annual Plan: $300/yr',
		group: SUBSCRIPTION_TYPES.INSTITUTIONAL
	}];

var syndromesXrefTypes = {
	OMIM: 'OMIM',
	POSSUM: 'POSSUM',
	ORPHANET: 'orphanet',
	OMIMPS: 'OMIMPS',
	NCBI: 'NCBI',
	NBK: 'NBK',
	LMD_FDNA: 'LMD_FDNA',
	GENE_REVIEW: 'GENE_REVIEW'
};

//
// Labels
//

var ERROR_LABELS = {
	UPLOAD_INVALID_FILES: 'One or more of the selected files was not in a supported format or the file size was too large.'
};

var otherRegisterOptions = _.map(_.get(window, 'user_constants.notHealthcare', []), function(element) {
    return _.extend({}, element, {value: element.url});
});

const CAPTURE_METHOD = {
	DRAG_AND_DROP: 'DRAG_AND_DROP',
	FILE_BROWSER: 'FILE_BROWSER',
}

const CAMERA_USED = {
	PHONE_FRONTAL: 'PHONE_FRONTAL',
	PHONE_BACK: 'PHONE_BACK',
	EXTERNAL: 'EXTERNAL'
}

const CASE_SOURCE = {
	WEBAPP: 'WEBAPP',
	PATIENT_INTAKE: 'PATIENT_INTAKE',
}

var ULTRA_RARE_OPTIONS = [
    {
        label: 'Syndrome Matches Only',
        value: 1
    },
    {
        label: 'Diagnosed Patient Matches Only',
        value: 2
    },
    {
        label: 'My Team Cases Only',
        value: 3
    }
];

var UNDIAGNOSED_OPTIONS = [
    {
        label: 'All Patient Matches',
        value: 1
    },
    {
        label: 'My Team Cases Only',
        value: 2
    }
];

var COOKIES_OPTIONS = [
	"checkbox_performance",
	"checkbox_others",
	"checkbox_necessary",
	"checkbox_functional",
	"checkbox_analytics",
	"checkbox_advertisement",
]

module.exports = {
	MEASUREMENT_NORMAL_THEME: measurementNormalTheme,
	MEASUREMENT_LEFT_THEME: measurementLeftTheme,
	DECIMAL_PLACES:			DECIMAL_PLACES,
    CASE_STATUS:            CaseStatus,
    CASE_DIAGNOSIS:         CaseDiagnosis,
    CASE_TYPE:              CaseType,
    GENDER:                 Gender,
    ETHNICITY:              Ethnicity,
    INHERITANCE:            Inheritance,
    EXCLUSION:              Exclusion,
    ORDER_DIAGNOSES_SCORE:  OrderDiagnosesScore,
    SYNDROME_DIAGNOSES:		syndromeDiagnosisOptions,
	GENE_DIAGNOSES:		    geneDiagnosisOptions,
    CHARTLIST:              ChartList,
	SD_MAX:					SD_MAX,
	SD_MIN:					SD_MIN,
	PERCENTILE_MAX:			PERCENTILE_MAX,
	PERCENTILE_MIN:			PERCENTILE_MIN,
	PUSHER_EVENT_TYPES: 	pusherEventTypes,
	MEASUREMENT_TYPES:		Measurements,
	GROUPED_MEASUREMENT_TYPES:	GroupedMeasurements,
	MAX_UPLOAD_FILE_ZIE:	MAX_UPLOAD_FILE_ZIE,
	ACCEPTED_MIME_TYPES: 	ACCEPTED_MIME_TYPES,
	IMAGE_TYPES:			ImageTypes,
	IMAGE_TYPE_LABELS:		ImageTypeLabels,
    USER_TITLE:             UserTitle,
    PROFESSION:             Profession,
    SPECIALITY:             Speciality,
	COUNTRIES:				Countries,
	IMAGE_RESIZING_PARAMS:  IMAGE_RESIZING_PARAMS,
	CASE_ACCESS_LEVELS:		CASE_ACCESS_LEVELS,
	PRIVACY_ITEMS:			PRIVACY_ITEMS,
	PRIVACY_ITEMS_DESCRIPTION: PRIVACY_ITEMS_DESCRIPTION,
	SUBSCRIPTION_TYPES: 	SUBSCRIPTION_TYPES,
	SUBSCRIPTION_PLANS:	 	SUBSCRIPTION_PLANS,
	ERROR_LABELS:			ERROR_LABELS,
	LMD_SUBSCRIPTION_INFO:  LMD_SUBSCRIPTION_INFO,
	SYNDROMES_XREF_TYPES: 	syndromesXrefTypes,
    OTHER_REGISTER_OPTIONS: otherRegisterOptions,
	CAPTURE_METHOD: 		CAPTURE_METHOD,
	CAMERA_USED:			CAMERA_USED,
    CASE_SOURCE:			CASE_SOURCE,
	ULTRA_RARE_OPTIONS:     ULTRA_RARE_OPTIONS,
	UNDIAGNOSED_OPTIONS:    UNDIAGNOSED_OPTIONS,
	COOKIES_OPTIONS:        COOKIES_OPTIONS
};



// WEBPACK FOOTER //
// ./constants.js